import { Component, Input, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RsvpStore } from '../../service/rsvp.store';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { Rsvp } from '../../models/rsvp';
import { PioneerValidators } from '../../../shared/utils/pioneer.validators';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'pioneer-rsvp-form',
  templateUrl: './rsvp-form.component.html'
})
export class RsvpFormComponent implements OnInit {

  @Input()
  event: OnyxEvent;

  rsvpForm: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private rsvpStore: RsvpStore,
              private reservationCompareStore: ReservationCompareStore) { }

  ngOnInit() {

    if (!this.event) {
      throw new Error('The "event" attribute must be specified to use the RsvpFormComponent component');
    }
    this.initForm(null);
  }

  private initForm(rsvp: Rsvp) {
    this.rsvpForm = this.formBuilder.group({
      firstName: [ rsvp ? rsvp.firstName : null, [ Validators.maxLength(50) ] ],
      lastName: [ rsvp ? rsvp.lastName : null, [ Validators.required, Validators.maxLength(50) ] ],
      roomRate: [ rsvp ? rsvp.roomRate : null, [ Validators.required, PioneerValidators.isValidAmountInRange(0, 9999999999999.99) ] ],
      checkInDate: [rsvp ? rsvp.checkInDate : null, [Validators.required, PioneerValidators.isDate]],
      checkOutDate: [rsvp ? rsvp.checkOutDate : null, [Validators.required, PioneerValidators.isDate]],
      roomType: [rsvp ? rsvp.roomType : null, [Validators.maxLength(6)]],
      confirmation: [rsvp ? rsvp.confirmation : null, [Validators.maxLength(32)]],
    }, {
        validator: PioneerValidators.isEndDateAfterStartDateCrossValidator('checkInDate', 'checkOutDate')
      }
    );
  }

  public init(rsvp: Rsvp) {
    this.initForm(rsvp);
  }

  addRsvp(): Observable<any> {
    return this.addUpdateRsvp();
  }

  updateRsvp(eventRsvpId: number): Observable<any> {
    return this.addUpdateRsvp(eventRsvpId);
  }

  /**
   * Adds or updates and RSVP by the RSVP identifier
   *
   * @param [eventRsvpId] Optional: the ID of the RSVP
   * @returns an observer
   */
  private addUpdateRsvp(eventRsvpId?: number): Observable<any> {
    this.rsvpForm.disable();

    const obs$ = new Observable((observer) => {
      let methodObs$: Observable<any>;
      if (eventRsvpId) {
        methodObs$ = this.rsvpStore.updateRsvp(this.setRsvp(eventRsvpId));
      } else {
        methodObs$ = this.rsvpStore.addRsvp(this.setRsvp());
      }
      methodObs$.catch((error) => {
        this.rsvpForm.enable();
        observer.error();
        return Observable.throw(error);
      }).subscribe(() => {
        this.reservationCompareStore.refreshCurrentRsvpList(this.event.eventId);
        this.resetForm();
        this.rsvpForm.enable();
        observer.next();
      });
    });

    return obs$;
  }

  /**
   * Sets an RSVP with the data from the form
   *
   * @param [eventRsvpId] Optional: the ID of the RSVP
   * @returns the new RSVP created
   */
  private setRsvp(eventRsvpId?: number): Rsvp {
    return new Rsvp({
      eventRsvpId: eventRsvpId ? eventRsvpId : null,
      eventId: this.event.eventId,
      firstName: this.rsvpForm.get('firstName').value,
      lastName: this.rsvpForm.get('lastName').value,
      roomRate: this.rsvpForm.get('roomRate').value,
      checkInDate: this.rsvpForm.get('checkInDate').value,
      checkOutDate: this.rsvpForm.get('checkOutDate').value,
      roomType: this.rsvpForm.get('roomType').value,
      confirmation: this.rsvpForm.get('confirmation').value,
    });
  }

  cancelEditRsvp() {
    this.resetForm();
  }

  private resetForm(): void {
    this.rsvpForm.reset({
      firstName: null,
      lastName: null,
      roomRate: null,
      checkInDate: null,
      checkOutDate: null,
      roomType: null,
      confirmation: null,
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/rsvp/rsvp-form/rsvp-form.component.ts